export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return
  }

  const { user } = useUser()
  const supabase = useSupabaseClient<Supabase>()
  const data = useData()
  const returnPath = `/event/${to.params.id}`
  const resourceId = useShortId(to.params.id)
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  const existingScope = ((data as any).scopes as Map<string, any>).get(
    resourceId,
  )

  if (!existingScope) {
    if (user.value) {
      const { data: scopes } = await supabase
        .from('scopes')
        .select()
        .eq('resource_id', resourceId)
        .eq('scoped_user_id', user.value.id)
        .in('scope', ['editor', 'owner'])

      if (Array.isArray(scopes) && scopes.length > 0) {
        data.cacheMany('scopes', scopes)
      } else {
        return navigateTo(returnPath)
      }
    }
  } else if (
    existingScope.scope !== 'editor' &&
    existingScope.scope !== 'owner'
  ) {
    return navigateTo(returnPath)
  }
})
